import { useMemo, useState } from "react";
import { events } from "@/mocks/crash";
import SectionHeading from "./SectionHeading";

export default function EventHub() {
  const tags = useMemo(() => ["全部", ...Array.from(new Set(events.map((e) => e.tag)))], []);
  const [active, setActive] = useState("全部");
  const list = active === "全部" ? events : events.filter((e) => e.tag === active);

  return (
    <section id="events" className="relative bg-paper-100/70 py-16 md:py-24 scroll-mt-16">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="BREAKING · 事件现场"
            title="最近的人设崩塌现场"
            desc="从清纯到学霸、从完美伴侣到独立大女主，实时盘点热度攀升的塌房事件，帮你快速抓住吃瓜重点。"
          />
          <div className="inline-flex flex-wrap items-center gap-1.5">
            {tags.map((t) => (
              <button
                key={t}
                type="button"
                onClick={() => setActive(t)}
                className={`px-4 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  active === t
                    ? "bg-ink-900 text-paper-50"
                    : "bg-paper-50 text-ink-800 hover:bg-paper-200/70"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {list.map((ev, i) => (
            <article
              key={ev.title}
              className={`group flex flex-col overflow-hidden rounded-2xl bg-paper-50 border border-paper-200/70 transition-transform duration-300 hover:-translate-y-1 ${
                i === 0 ? "lg:col-span-2 lg:row-span-2" : ""
              }`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? "aspect-[16/9] lg:aspect-auto lg:h-72" : "aspect-[16/10]"}`}>
                <img
                  src={ev.img}
                  alt={`${ev.tag}类型的人设崩塌事件配图：${ev.title}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 inline-flex items-center gap-1 rounded-full bg-ink-950/70 backdrop-blur text-paper-50 text-xs font-medium px-3 py-1">
                  <i className="ri-fire-fill text-coral-400"></i>
                  {ev.tag}
                </span>
                <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 rounded-full bg-paper-50/90 text-ink-900 text-xs font-semibold px-2.5 py-1">
                  <i className="ri-flashlight-line"></i> 热度 {ev.heat}
                </span>
              </div>
              <div className={`flex flex-1 flex-col p-4 md:p-5 ${i === 0 ? "lg:p-6" : ""}`}>
                <h3
                  className={`group-hover:text-coral-600 transition-colors leading-snug ${
                    i === 0 ? "text-xl md:text-2xl font-semibold" : "text-base font-semibold"
                  }`}
                >
                  {ev.title}
                </h3>
                <p className={`mt-2 text-ink-700/80 leading-relaxed ${i === 0 ? "" : "text-sm"}`}>
                  {ev.desc}
                </p>
                <div className="mt-auto pt-4 flex items-center justify-between text-xs text-ink-700/55">
                  <span>{ev.time}</span>
                  <a
                    href="#deep"
                    className="inline-flex items-center gap-1 text-coral-600 hover:text-coral-700 font-medium cursor-pointer"
                  >
                    进入复盘 <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}